import Vue from 'vue';
import VueGtm from '@gtm-support/vue2-gtm';
import VueSanitize from 'vue-sanitize';
import vuetify from '@/plugins/vuetify';
import TextelPolyglot from '@/plugins/vue-textel-polyglot';
import '@/assets/styles/global.scss';
import { registerServiceWorker } from '@/services/notifications';
import App from './App.vue';
import router from './router';
import store from './store';
import { logAcxessException, logType } from './services/logger';

Vue.config.productionTip = false;

Vue.use(TextelPolyglot);
Vue.use(VueSanitize, {
  allowedTags: ['b', 'i', 'em', 'strong', 'a', 'br'],
  allowedAttributes: {
    a: ['href'],
  },
});

const isProduction = process.env.VUE_APP_HOSTING_ENV === 'PROD';
let lockResolver;

Vue.use(VueGtm, {
  id: 'GTM-PDF82ZP',
  defer: false, // Script can be set to `defer` to speed up page load at the cost of less accurate results (in case visitor leaves before script is loaded, which is unlikely but possible). Defaults to false, so the script is loaded `async` by default
  compatibility: false, // Will add `async` and `defer` to the script tag to not block requests for old browsers that do not support `async`
  enabled: isProduction, // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
  debug: false, // Whether or not display console logs debugs (optional)
  loadScript: true, // Whether or not to load the GTM Script (Helpful if you are including GTM manually, but need the dataLayer functionality in your components) (optional)
  vueRouter: router, // Pass the router instance to automatically sync with router (optional)
  trackOnNextTick: false, // Whether or not call trackView in Vue.nextTick
});

new Vue({
  router,
  vuetify,
  store,
  render: (h) => h(App),
}).$mount('#app');

registerServiceWorker().then(() => {
  logAcxessException(logType.Info, 'service worker registered');
});

if (navigator && navigator.locks && navigator.locks.request) {
  const promise = new Promise((res) => {
    lockResolver = res;
  });

  navigator.locks.request('textel_signalr_tab_lock', { mode: 'shared' }, () => promise);
}
